import React from "react";
import { useLocation } from "react-router-dom";
import ServiceProvidersTable from "./components/ServiceProvidersTable";
import ServiceProvidersDashboardBanner from "./components/ServiceProvidersDashboardBanner";
import { GlobalContainer } from "../../common/components/Container";

const ServiceProviders = () => {
  const { state } = useLocation();
  return (
    <GlobalContainer theme="purple" animated={false}>
      <ServiceProvidersDashboardBanner
        type="banner"
        theme="purple"
        serviceData={state}
      />
      <ServiceProvidersTable serviceData={state} />
    </GlobalContainer>
  );
};

export default ServiceProviders;
